const { filter, isEmpty } = require('lodash');

class DeliverySaverPlanSelectionController {
    constructor($q, $location, $state, settings, deliverySaverService, shopperService, deliverySaverAnalytics) {
        this.$q = $q;
        this.$location = $location;
        this.$state = $state;
        this.settings = settings;
        this.deliverySaverService = deliverySaverService;
        this.shopperService = shopperService;
        this.deliverySaverAnalytics = deliverySaverAnalytics;
    }

    $onInit() {
        if (!(this.settings.deliverySaver && this.settings.deliverySaver.isEnabled &&
                this.settings.payment && this.settings.payment.enableDigitalPay)) {
            this.$state.go('shop.deliveryplus.comingsoon');
            return;
        }

        this.isLoading = true;
        this.selectedPlanId = -1;
        this.hasLoadPlansError = false;

        this.hasActiveDeliveryPass = false;
        this.hasActiveDeliverySaver = false;
        this.hasSuspendedDeliverySaver = false;
        this.isBusinessAccount = false;
        this.showBusinessPlans = false;
        this.isEligibleForDeliverySaver = true;

        this.anyDayConsumerPlans = [];
        this.midweekConsumerPlans = [];
        this.anyDayBusinessPlans = [];
        this.midweekBusinessPlans = [];

        this.$q.all([
            this.getEligibility(),
            this.getPlans(),
        ]).then(() => {
            this.isLoading = false;
        });
    }

    getPlans() {
        return this.deliverySaverService.listPlans()
            .then((response) => {
                this.anyDayConsumerPlans = filter(response.Plans, p => p.IsAnyDay && !(p.Metadata && p.Metadata.IsBusinessToBusiness));
                this.midweekConsumerPlans = filter(response.Plans, p => p.IsMidweek && !(p.Metadata && p.Metadata.IsBusinessToBusiness));
                this.anyDayBusinessPlans = filter(response.Plans, p => p.IsAnyDay && p.Metadata && p.Metadata.IsBusinessToBusiness);
                this.midweekBusinessPlans = filter(response.Plans, p => p.IsMidweek && p.Metadata && p.Metadata.IsBusinessToBusiness);
                if (response.Plans[0] && response.Plans[0].Metadata.SessionGroup) {
                    this.deliverySaverAnalytics.push({ sessionGroup: response.Plans[0].Metadata.SessionGroup });
                }
            })
            .catch(() => {
                this.hasLoadPlansError = true;
            });
    }

    getEligibility() {
        return this.deliverySaverService.getEligibility()
            .then((response) => {
                this.dateEligibleForDeliverySaver = response.DateEligibleForDeliverySaver;
                this.hasActiveDeliveryPass = response.HasActiveDeliveryPass;
                this.hasActiveDeliverySaver = response.HasActiveDeliverySaver;
                this.hasSuspendedDeliverySaver = response.HasSuspendedDeliverySaver;
                this.isBusinessAccount = response.IsBusinessAccount;
                this.showBusinessPlans = response.IsBusinessAccount;
                this.isEligibleForDeliverySaver = response.IsEligibleForDeliverySaver;
            });
    }

    isPersonalAccount() {
        return !this.shopperService.IsGuest && !this.isBusinessAccount;
    }

    hasPlans() {
        return (
            (!this.showBusinessPlans && !(isEmpty(this.anyDayConsumerPlans) && isEmpty(this.midweekConsumerPlans))) ||
            (this.showBusinessPlans && !(isEmpty(this.anyDayBusinessPlans) && isEmpty(this.midweekBusinessPlans)))
        );
    }
}

DeliverySaverPlanSelectionController.$inject = ['$q', '$location', '$state', 'Settings', 'DeliverySaverService', 'ShopperService', 'DeliverySaverAnalytics'];

const DeliverySaverPlanSelectionComponentDefinition = {
    controller: DeliverySaverPlanSelectionController,
    template: require('./delivery-saver-plan-selection.component.html').trim(),
};

module.exports = {
    DeliverySaverPlanSelectionController,
    DeliverySaverPlanSelectionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/planselection/delivery-saver-plan-selection.component.js